/**
 * Natural Dye Store — Scroll Reveal & Animations
 * IntersectionObserver-based reveal system
 */
(function () {
  'use strict';

  const REVEAL_SELECTOR = '.nds-reveal';
  const VISIBLE_CLASS = 'is-visible';
  const THRESHOLD = 0.12;
  const ROOT_MARGIN = '0px 0px -40px 0px';

  let observer;

  function createObserver() {
    if (observer) return;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll(REVEAL_SELECTOR).forEach(function (el) {
        el.classList.add(VISIBLE_CLASS);
      });
      return;
    }
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(VISIBLE_CLASS);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: THRESHOLD, rootMargin: ROOT_MARGIN });
  }

  function observeElements(root) {
    var scope = root || document;
    scope.querySelectorAll(REVEAL_SELECTOR + ':not(.' + VISIBLE_CLASS + ')').forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    createObserver();
    if (observer) observeElements();
    // Re-observe on Shopify section events (editor + AJAX)
    document.addEventListener('shopify:section:load', function (e) {
      if (observer) observeElements(e.target);
    });
    // MutationObserver for dynamically added elements
    var bodyObserver = new MutationObserver(function (mutations) {
      var hasNew = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.matches && node.matches(REVEAL_SELECTOR) || node.querySelector && node.querySelector(REVEAL_SELECTOR))) {
            hasNew = true;
          }
        });
      });
      if (hasNew && observer) observeElements();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
